import getlogin from './getLogin'
import accessList from './accessList'
import usemodal from './useModal'
import alertmodal from './alertModal'
import loadscreenmodal from './loadScreenModal'
import commonaxios from './commonAxios'
import commonquery from './commonQuery'
import commonqueryiot from './commonQueryIoT'
import exportcsv from './exportCsv'
import systemform from './systemForm'
import sensormodal from './sensorModal'
import stackBar from './stackBar'
import wireUseInformation from './wireUseInformation'
import workorderHistoryWireUseInformation from './workorderHistoryWireUseInformation'
import headingProduceInformation from './headingProduceInformation'
import produceInformationHead from './produceInformationHead'
import produceInformationThread from './produceInformationThread'
import produceInformationHeat from './produceInformationHeat'
import produceInformation from './produceInformation'
import workCodeInformation from './workCodeInformation'
import workorderHistoryCodeInformation from './workorderHistoryCodeInformation'
import moldUseInformation from './moldUseInformation'
import bucketUseInformation from './bucketUseInformation'
import inspectionUseInformation from './inspectionUseInformation'
import totalProduceTime from './totalProduceTime'
import operateLogData from './operateLogData'
import workorderHistoryData from './workorderHistoryData'
import alarmHistoryData from './alarmHistoryData'
import queryResult from './queryResult'
import singleChart from './singleChart'
import machineHealth from './machineHealth'
import activationData from './activationData'
import yieldStatisticsData from './yieldStatisticsData'
import selectDevice from './selectDevice'
import sideBarTree from './sideBarTree'
import threadUseInformation from './threadUseInformation'
import htWorkData from './htWorkData'
import machineCamera from './machineCamera'
import previousPage from './previousPage'
import workCodeInformationPackage from './workCodeInformationPackage'
import shipmentInformation from './shipmentInformation'
import produceInformationPackage from './produceInformationPackage'
import packageInformation from './packageInformation'
import palletInformation from './palletInformation'
import workorderHistoryPackageData from './workorderHistoryPackageData'
import workorderHistoryContainerData from './workorderHistoryContainerData'
import wireInquireResult from './wireInquireResult'
import heatTreatmentInquireResult from './heatTreatmentInquireResult'
import containerDetail from './containerDetail'
import containerInformation from './containerInformation'
import containerTime from './containerTime'
import containerShipment from './containerShipment'
import manualRecordData from './manualRecordData'
import inspectTimeoutData from './inspectTimeoutData'
import inspectTimeoutDetailData from './inspectTimeoutDetailData'


export default {
    getlogin,
    accessList,
    usemodal,
    alertmodal,
    loadscreenmodal,
    commonaxios,
    commonquery,
    commonqueryiot,
    exportcsv,
    systemform,
    sensormodal,
    stackBar,
    wireUseInformation,
    workorderHistoryWireUseInformation,
    headingProduceInformation,
    produceInformationHead,
    produceInformationThread,
    produceInformationHeat,
    produceInformation,
    workCodeInformation,
    workorderHistoryCodeInformation,
    moldUseInformation,
    bucketUseInformation,
    inspectionUseInformation,
    totalProduceTime,
    operateLogData,
    workorderHistoryData,
    alarmHistoryData,
    queryResult,
    singleChart,
    machineHealth,
    activationData,
    yieldStatisticsData,
    selectDevice,
    sideBarTree,
    threadUseInformation,
    machineCamera,
    htWorkData,
    previousPage,
    workCodeInformationPackage,
    shipmentInformation,
    produceInformationPackage,
    packageInformation,
    palletInformation,
    workorderHistoryPackageData,
    workorderHistoryContainerData,
    wireInquireResult,
    heatTreatmentInquireResult,
    containerDetail,
    containerInformation,
    containerTime,
    containerShipment,
    manualRecordData,
    inspectTimeoutData,
    inspectTimeoutDetailData,
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js